export default {"src":"/_next/static/media/ic-toggle-arrow-up.70b65a8e.svg","height":29,"width":28,"blurWidth":0,"blurHeight":0};